






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    filters: {
        formatDate(value: Date): string {
            return value.getFullYear().toString()
        },
    },
})
export default class Footer extends Vue {
    now = new Date()
    // @Prop() private title!: string;
}
